export default __webpack_public_path__ + "static/media/logo-desjardins.246a51da.png";